import React from "react";
import styled from "styled-components";
import { ActionButtonProps } from "./ActionButton.types";
import "./ActionButton.scss";

const actionsTypeStyle = [
  {
    name: "approve",
    color: "#fff",
    background: "#3F51B5"
  },
  {
    name: "reject",
    color: "#FD4C63",
    background: "#FFEDF0"
  },
  {
    name: "view",
    color: "#5BCEAE",
    background: "#EFFAF7"
  }
]

const ActionButtonWrapper = styled.button`
  background: ${props => props.theme.background};
  color: ${props => props.theme.color};
  border-radius: 5px;
  padding: 8px 17px;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 15px;
  text-transform: capitalize;
  border: none;
  outline: none;
`

export const ActionButton: React.FC<ActionButtonProps> = ({ actionType=  'approve', text, onPress }) => {

  const getActionStyle = (name: string) => {
    let style = actionsTypeStyle.find(item => item.name == name);
    if(style){
      return style;
    } else {
      return actionsTypeStyle[0];
    }
  }

  return(
    <ActionButtonWrapper onClick={() => onPress ? onPress() : null} theme={{ color: getActionStyle(actionType).color, background: getActionStyle(actionType).background }}>
      {text}
    </ActionButtonWrapper>
  )
};

